import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnippetService } from '../snippet.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-snippet-image',
    templateUrl: './snippet-image.component.html',
    styleUrls: ['./snippet-image.component.scss']
})
export class SnippetImageComponent implements OnInit {
    @Input() snippet;
    @Output() action: EventEmitter<any> = new EventEmitter<any>();

    imageLibraryType = 'cms';
    showImageLibrary = false;
    showConfirmation = false;
    snippetEditModal = false;

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };
    constructor(
        private snippetService: SnippetService,
        private toastrService: ToastrService,
    ) { }

    ngOnInit() {
    }

    imageSelected(e) {
        this.snippet.content = e.url;
        this.showImageLibrary = false;
        this.snippetService.saveSnippet(this.snippet).subscribe(data => {
            this.toastrService.success('Page contents updated');
        });
    }
    modalAction(e) {
        this.showImageLibrary = false;
    }
    viewImageLibrary(type) {
        this.imageLibraryType = type;
        this.showImageLibrary = true;
    }

    deleteConfirm() {
        this.confirmationData.title = 'Please confirm you would like to remove this section';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
    }

    confirmAction(e) {
        if (e.action) {
            this.snippetService.deleteSnippet(this.snippet).subscribe(data => {
                this.action.emit(true);
            });
        }
        this.confirmationData.open = false;
    }
    editSnippet() {
        this.snippetEditModal = true;
    }
    editModalAction(e) {
        this.snippetEditModal = false;
        if (e.completed) {
            this.toastrService.success('Page contents updated');
        }
    }

}
